import React from 'react'
import { TextField } from '@sencha/ext-modern'
import { getMixedProps, handleValueChange } from '../blockPublic'
import { useEventHandler, useInstData } from 'tyan/public/hooks'
import h5Scan from './h5Scan'
import feiShuScan from './feiShuScan'
import dingDingScan from './dingDingScan'

const doScan = (scanProps) => {
	(Tyan.isFeiShu ? feiShuScan : (Tyan.isDingDing ? dingDingScan : h5Scan))(scanProps)
}

const renderLiveScan = config => {
	const { key } = config.field || {}
	return <LiveScan key={key} config={config} />
}

const LiveScan = props => {
	const { me } = useInstData(props)
	let { config: { field: { handler, ...field }, onChange, initValues, /* changedValues,  */defaultStyle } } = props
	const { props: { key, ...compProps } } = getMixedProps('_livescan', [defaultStyle, field])
	const { disabled } = compProps

	const handleScanned = data => {
		handler
			? handler(data, onChange)
			: me.cmp && me.cmp.setValue(data)
	}

	const scanHandler = useEventHandler(() => doScan({ onScanned: handleScanned }))
	// const triggerHandler = useEventHandler(() => doScan({ handler, onChange, initValues, ...field }))
	return <TextField {...compProps} ref={ref => ref && (me.cmp = ref.cmp)}
		onChange={handleValueChange(field.name, initValues[field.name], onChange, 'string')}
		triggers={{
			scan: { iconCls: 'x-fa fa-qrcode', side: 'right', handler: scanHandler, hidden: disabled }
		}}
	/>
}

export default renderLiveScan
export { doScan }